document.addEventListener('DOMContentLoaded', function () {
    console.log('Swatch script loaded');

    document.addEventListener('click', function (e) {
        const swatch = e.target.closest('.color-meta-inputs');
        if (!swatch) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const url = swatch.dataset.productUrl;
        if (!url) return;

        const currentSection = document.querySelector('.product');
        if (!currentSection) return;

        const sectionId = currentSection.dataset.sectionId;
        if (!sectionId) return;

        document.querySelectorAll('.color-meta-inputs').forEach(link => {
            link.classList.remove('active');
        });
        swatch.classList.add('active');


        fetch(`${url}?sections=${sectionId}`)
            .then(response => response.json())
            .then(data => {

                if (!data[sectionId]) {
                    console.warn('Section not returned — fallback');
                    window.location.href = url;
                    return;
                }

                const parser = new DOMParser();
                const html = parser.parseFromString(data[sectionId], 'text/html');
                const newSection = html.querySelector('.product');

                if (!newSection) {
                    window.location.href = url;
                    return;
                }

                if (window.theme && theme.sections) {
                    const oldInstance = theme.sections.instances.find(inst => inst.id === sectionId);
                    if (oldInstance && oldInstance.onUnload) oldInstance.onUnload();
                }


                currentSection.replaceWith(newSection);

                if (window.theme && window.theme.Product) {
                    new theme.Product(newSection, theme.productJSON);
                }

                // Trigger events for other scripts
                document.dispatchEvent(new Event('shopify:section:load'));
                document.dispatchEvent(new CustomEvent('theme:section:load'));

                window.history.pushState({ path: url }, '', url);

                newSection.querySelectorAll('img, svg').forEach(el => {
                    // el.style.opacity = '1';
                    // el.style.transform = 'none';
                });

            })
            .catch(error => {
                console.error('Section load error:', error);
                window.location.href = url;
            });

    }, true);
});

